import { getOwnerDetails } from '../../utils/utils';
import { USER_TYPE } from '../../utils/constants/user';
import { DEFAULT_COUNTRY_CODE } from './constants';
import type { ContactLineInput } from './types';

export const buildContactLine = ({ userType, platformUserData, partnerOwner }: ContactLineInput): string => {
    if (userType === USER_TYPE.COMPANY && platformUserData) {
        if (!platformUserData.name) return '';
        if (platformUserData.mobileNumber) {
            const countryCode = platformUserData.countryCode ? `+${platformUserData.countryCode}` : DEFAULT_COUNTRY_CODE;
            return `${platformUserData.name}: (${countryCode}) ${platformUserData.mobileNumber}`;
        }
        return platformUserData.emailId ? `${platformUserData.name}: ${platformUserData.emailId}` : '';
    }

    if (partnerOwner?.name && partnerOwner?.mobileNumber) {
        const countryCode = partnerOwner.countryCode ? `+${partnerOwner.countryCode}` : DEFAULT_COUNTRY_CODE;
        return `${partnerOwner.name}: (${countryCode}) ${partnerOwner.mobileNumber}`;
    }
    if (partnerOwner?.name && partnerOwner?.emailId) {
        return `${partnerOwner.name}: ${partnerOwner.emailId}`;
    }

    const details = getOwnerDetails(userType);
    return `${details.name}: (${DEFAULT_COUNTRY_CODE}) ${details.phone}`;
};
